/* Retro Finder PDP tests B / C / D.
   <pdpt-picker> wraps a whole variant section. It reads the product's variants and option roles from
   <script data-pdpt-data> (snippets/pdp-test-data.liquid), drives the real variant (hidden id input, ?variant= in the URL,
   price, compare-at, the computed Save tag, sold-out state), and lets the theme's own <product-form> do the cart add and
   open the cart drawer. Every option click also sends the same swatch_click event the live page sends. */
(function () {
  if (customElements.get('pdpt-picker')) return;

  function track(name, params) {
    if (window.__pdpVariant && params.pdp_variant === undefined) params.pdp_variant = window.__pdpVariant;
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var whole = Math.round(cents) % 100 === 0;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return '$' + (whole ? cents / 100 : (cents / 100).toFixed(2));
    }
  }

  class PdptPicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var dataEl = this.querySelector('script[data-pdpt-data]');
      if (!dataEl) return;
      this.d = JSON.parse(dataEl.textContent);
      var start = this.d.variants.filter(function (v) { return v.id === this.d.selected; }, this)[0] || this.d.variants[0];
      this.sel = start.o.slice();
      this.form = this.querySelector('product-form form');
      this.idInput = this.querySelector('input.product-variant-id');
      this.submit = this.querySelector('.product-form__submit');
      this.buttons = [].slice.call(this.querySelectorAll('button[data-g]'));
      this.buttons.forEach(function (b) {
        b.addEventListener('click', function () { this.pick(b.dataset.g, b.dataset.v); }.bind(this));
      }, this);
      this.setupSticky();
      this.setupGallery();
      this.render();
      this.initHero();
    }

    /* C: the typing video is the hero for the frame it was shot on; reduced-motion and data-saver visitors get the poster only */
    initHero() {
      var video = this.querySelector('[data-pdpt-hero-video]'), hero = this.querySelector('[data-pdpt-hero-img]');
      if (!video) return;
      var on = this.sel[this.d.roles.frame] === video.dataset.frame;
      video.hidden = !on;
      if (hero) hero.hidden = on;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saver = navigator.connection && navigator.connection.saveData;
      video.muted = true;
      if (reduce || saver) { video.removeAttribute('autoplay'); video.pause(); return; }
      var pr = video.play();
      if (pr && pr.catch) pr.catch(function () {});
    }

    find(sel) {
      return this.d.variants.filter(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); })[0] || null;
    }

    /* the nearest available variant that has this value: keeps as many of the shopper's other choices as possible */
    steer(idx, val) {
      var best = null, bestScore = -1;
      this.d.variants.forEach(function (v) {
        if (v.o[idx] !== val) return;
        var score = v.o.reduce(function (a, x, i) { return a + (i !== idx && x === this.sel[i] ? 1 : 0); }.bind(this), 0) + (v.a ? 10 : 0);
        if (score > bestScore) { best = v; bestScore = score; }
      }, this);
      return best;
    }

    pick(role, val) {
      var idx = this.d.roles[role];
      if (idx < 0) return;
      var trial = this.sel.slice();
      trial[idx] = val;
      var asked = this.find(trial);
      track('swatch_click', {
        product_handle: this.d.handle,
        option_name: this.d.names[idx],
        option_value: val,
        variant_id: asked ? String(asked.id) : ''
      });
      var v = asked && asked.a ? asked : this.steer(idx, val) || asked;
      if (!v) return;
      var imgBefore = this.variant ? this.variant.img : null;
      this.sel = v.o.slice();
      this.render();
      this.dispatchEvent(new CustomEvent('pdpt:picked', { detail: { role: role, variant: v, frameChanged: !!v.img && v.img !== imgBefore }, bubbles: true }));
    }

    flashFor(v) {
      var f = this.d.flash;
      if (!f || !f.on || !f.label || !Array.isArray(f.list)) return false;
      var title = v.t + ' / ';
      return f.list.some(function (p) { return title.indexOf(String(p).trim() + ' / ') === 0; });
    }

    render() {
      var v = this.find(this.sel);
      this.variant = v;
      var roles = this.d.roles;
      /* option buttons: pressed, and struck through when no available variant has that value with the other current picks */
      this.buttons.forEach(function (b) {
        var idx = roles[b.dataset.g];
        var on = this.sel[idx] === b.dataset.v;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var ok = this.d.variants.some(function (x) {
          return x.a && x.o[idx] === b.dataset.v && x.o.every(function (o, i) { return i === idx || o === this.sel[i]; }, this);
        }, this);
        if (ok) b.removeAttribute('data-unavailable'); else b.setAttribute('data-unavailable', 'true');
      }, this);
      /* real variant: hidden id, button state, URL */
      if (v) {
        if (this.idInput) { this.idInput.value = v.id; this.idInput.disabled = !v.a; }
        if (this.submit) {
          this.submit.disabled = !v.a;
          this.submit.setAttribute('aria-disabled', v.a ? 'false' : 'true');
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(null, '', url.toString());
        } catch (e) { /* the URL is a convenience */ }
      }
      var root = this;
      function all(s) { return [].slice.call(root.querySelectorAll(s)); }
      var onSale = v && v.c > v.p;
      all('[data-pdpt-now]').forEach(function (e) { if (v) e.textContent = money(v.p); });
      all('[data-pdpt-was]').forEach(function (e) { if (v) { e.textContent = money(v.c); e.hidden = !onSale; } });
      var flash = v && this.flashFor(v);
      all('[data-pdpt-save]').forEach(function (e) {
        if (!v) return;
        if (e.dataset.mode === 'flash_or_save') {
          if (flash) { e.className = e.dataset.pillClass; e.textContent = this.d.flash.label; e.hidden = false; }
          else if (onSale) { e.className = e.dataset.saveClass; e.textContent = 'Save ' + money(v.c - v.p); e.hidden = false; }
          else e.hidden = true;
        }
        else if ((e.dataset.mode === 'flash' || e.dataset.mode === 'flash_only') && flash) { e.textContent = this.d.flash.label; e.hidden = false; }
        else if (e.dataset.mode === 'flash_only') e.hidden = true;
        else if (onSale) { e.textContent = 'Save ' + money(v.c - v.p); e.hidden = false; }
        else e.hidden = true;
      }, this);
      all('[data-pdpt-sticky-pill]').forEach(function (e) {
        if (flash && v) { e.textContent = this.d.flash.label; e.hidden = false; } else e.hidden = true;
      }, this);
      all('[data-pdpt-flashbar]').forEach(function (e) {
        if (flash && v) { e.textContent = this.d.flash.label + ' · ' + money(v.p) + (onSale ? ' (was ' + money(v.c) + ')' : ''); e.hidden = false; }
        else e.hidden = true;
      }, this);
      all('[data-pdpt-atc-label]').forEach(function (e) {
        if (!v) { e.textContent = 'Unavailable'; return; }
        e.textContent = v.a ? (e.closest('.pdpt-sticky') ? 'Add to cart' : (e.dataset.prefix || 'Add to cart') + (e.dataset.showPrice === 'true' ? ' · ' + money(v.p) : '')) : 'Sold out';
      });
      all('[data-sel]').forEach(function (e) { var i = roles[e.dataset.sel]; if (i > -1) e.textContent = this.sel[i]; }, this);
      all('[data-pdpt-summary]').forEach(function (e) {
        e.textContent = this.sel.filter(function (x) { return x && x !== 'Default Title'; }).join(' · ');
      }, this);
      all('[data-ships-frame]').forEach(function (e) { e.hidden = roles.frame < 0 || this.sel[roles.frame] !== e.dataset.shipsFrame; }, this);
      all('[data-pdpt-sticky-atc]').forEach(function (e) { e.disabled = !(v && v.a); });
    }

    /* sticky bar: appears once the main Add to cart scrolls out of view, and sits under the cookie bar (z-index 30 vs 40) */
    setupSticky() {
      var bar = this.querySelector('[data-pdpt-sticky]');
      var anchor = this.querySelector('[data-pdpt-atc-anchor]');
      if (!bar || !anchor) return;
      var btn = bar.querySelector('[data-pdpt-sticky-atc]');
      var self = this;
      if (btn) btn.addEventListener('click', function () {
        if (!self.submit || self.submit.disabled) return;
        var sv = self.variant;
        track('sticky_atc_click', { product_handle: self.d.handle, variant_id: sv ? String(sv.id) : '', price: sv ? sv.p / 100 : undefined, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
        if (self.form && typeof self.form.requestSubmit === 'function') self.form.requestSubmit(self.submit);
        else self.submit.click();
      });
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (e) {
        var show = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        bar.classList.toggle('show', show);
        document.documentElement.classList.toggle('has-sticky-atc', show);
      }).observe(anchor);
    }

    setupGallery() {
      var self = this;
      [].slice.call(this.querySelectorAll('.gal')).forEach(function (g) {
        var dots = g.parentNode.querySelectorAll('.dots i');
        if (!dots.length) return;
        g.addEventListener('scroll', function () {
          var i = Math.round(g.scrollLeft / g.clientWidth);
          [].forEach.call(dots, function (x, j) { x.classList.toggle('on', j === i); });
        }, { passive: true });
      });
      /* when the frame changes, the first gallery photo becomes that frame's own photo if the variant has one */
      this.addEventListener('pdpt:picked', function (ev) {
        if (!ev.detail.frameChanged) return;
        var v = ev.detail.variant;
        var first = self.querySelector('[data-pdpt-first-img]');
        if (first && v.img) { first.src = v.img; first.removeAttribute('srcset'); }
        var hero = self.querySelector('[data-pdpt-hero-img]');
        var video = self.querySelector('[data-pdpt-hero-video]');
        var isVideoFrame = video && self.sel[self.d.roles.frame] === video.dataset.frame;
        if (video) { video.hidden = !isVideoFrame; if (isVideoFrame && video.paused) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); } }
        if (hero) { hero.hidden = !!isVideoFrame; if (v.img && !isVideoFrame) hero.src = v.img; }
        var gal = self.querySelector('[data-pdpt-gallery]');
        if (gal) gal.scrollLeft = 0;
      });
      /* C: thumbnails swap the hero photo, the listen button toggles sound */
      [].slice.call(this.querySelectorAll('[data-pdpt-thumb]')).forEach(function (b) {
        b.addEventListener('click', function () {
          var hero = self.querySelector('[data-pdpt-hero-img]'), video = self.querySelector('[data-pdpt-hero-video]');
          if (video) video.hidden = true;
          if (hero) { hero.hidden = false; hero.src = b.dataset.src; hero.removeAttribute('srcset'); }
          [].forEach.call(self.querySelectorAll('[data-pdpt-thumb]'), function (x) { x.classList.toggle('on', x === b); });
        });
      });
      var play = this.querySelector('[data-pdpt-play]');
      var vid = this.querySelector('[data-pdpt-hero-video]');
      if (play && vid) {
        var label = play.querySelector('span');
        play.addEventListener('click', function () {
          track('sound_listen_tap', { product_handle: self.d.handle });
          if (typeof window.clarity === 'function') window.clarity('event', 'sound_listen_tap');
          vid.hidden = false;
          var hero = self.querySelector('[data-pdpt-hero-img]'); if (hero) hero.hidden = true;
          vid.muted = !vid.muted;
          play.classList.toggle('on', !vid.muted);
          if (label) label.textContent = vid.muted ? 'Listen In' : 'Sound on';
          if (!vid.muted) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }
      /* D: accordion steps, progress and summary follow the picks */
      var acc = [].slice.call(this.querySelectorAll('[data-pdpt-acc]'));
      if (acc.length) {
        var prog = this.querySelector('[data-pdpt-prog]'), progText = this.querySelector('[data-pdpt-prog-text]');
        function open(i) { acc.forEach(function (a, j) { a.classList.toggle('open', j === i); }); }
        function progress(n) {
          if (prog) prog.style.width = (n / acc.length * 100) + '%';
          if (progText) progText.textContent = n === acc.length ? 'Ready to add' : 'Step ' + n + ' of ' + acc.length;
          acc.forEach(function (a, j) { a.classList.toggle('done', j < n); });
        }
        acc.forEach(function (a, j) { var hb = a.querySelector(':scope > button'); if (hb) hb.addEventListener('click', function () { open(j); }); });
        this.addEventListener('pdpt:picked', function (ev) {
          var j = acc.findIndex(function (a) { return a.dataset.role === ev.detail.role; });
          if (j < 0) return;
          if (j + 1 < acc.length) { setTimeout(function () { open(j + 1); progress(j + 2); }, 350); }
          else progress(acc.length);
        });
        progress(1);
      }
    }
  }
  customElements.define('pdpt-picker', PdptPicker);
})();
